import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import t from "../list-item/list-item.js";
import { createElementBlock as n, createElementVNode as r, createVNode as i, normalizeClass as a, openBlock as o, renderSlot as s, resolveComponent as c, toDisplayString as l, withCtx as u } from "vue";
//#region components/combobox/combobox_empty-list.vue
var d = {
	name: "ComboboxEmptyList",
	components: { DtListItem: t },
	props: {
		message: {
			type: String,
			required: !0
		},
		itemClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		}
	}
}, f = {
	class: "d-combobox__empty-list",
	"data-qa": "dt-combobox-empty-list"
};
function p(e, t, d, p, m, h) {
	let g = c("dt-list-item");
	return o(), n("ol", f, [s(e.$slots, "default", {}, () => [i(g, {
		role: "option",
		"navigation-type": "none",
		type: "custom",
		class: a(["d-combobox__empty-list-item", d.itemClass])
	}, {
		default: u(() => [r("span", null, l(d.message), 1)]),
		_: 1
	}, 8, ["class"])])]);
}
var m = /* @__PURE__ */ e(d, [["render", p]]);
//#endregion
export { m as default };

//# sourceMappingURL=combobox-empty-list.js.map